import {
  ModuleParameters,
  ZFParameters,
} from "@/modules/launcher/LauncherModulesPistes";
import axios from "axios";
import { updateSelectionBilan } from "./updateSelectionBilan";
import { evolveState, InputCaseSession } from "@/modules/selection/ZFEvolve";
import { updateSelection } from "./updateSelection";
import { ResultBilan } from "@/modules/bilan/Bilan";
import { ResultZF } from "@/modules/launcher/ModuleRenderer";
export interface SessionInfo {
  visualFieldInput: string;
  visualFieldSelection: string;
  visualFieldSelectionId: string;
  resultsZF: ResultZF[] | null;
  resultsBilan: ResultBilan[] | null;
  targetEnCours_Zf_Bilan: string | null;
  initialTargetsLengthEncours_Zf_Bilan: number | null;
  status: "EN_COURS" | "PREVUE" | "REALISEE";
  parameters: {
    Bilan_Cv: ModuleParameters;
    ZF?: ZFParameters;
  };
}

interface SessionInfoItem {
  ZfSelected: boolean;
  Bilan_CvSelected: boolean;
  status: "EN_COURS" | "PREVUE" | "REALISEE";
  resultsZF: ResultZF[] | null;
  resultsBilan: ResultBilan[] | null;
  targetEnCours_Zf_Bilan: string | null;
  visualFieldSelectionId: string;
  visualFieldInput: InputCaseSession;
}

const getSessionInfo = (sessionId: number): Promise<SessionInfoItem> => {
  return axios
    .get(`/practitioner/session/${sessionId}`)
    .then((response) => {
      const sessionData = response.data;
      const adaptedParameters = sessionData.parameters.reduce(
        (
          acc: { [key: string]: ModuleParameters },
          param: { content: string }
        ) => {
          const content = JSON.parse(param.content);
          const key = content.sous_module;
          acc[key] = { ...acc[key], ...content };
          return acc;
        },
        {}
      );

      const sessionInfo: SessionInfoItem = {
        ZfSelected: adaptedParameters.ZF?.selected || false,
        Bilan_CvSelected: adaptedParameters.Bilan_Cv.selected || false,
        targetEnCours_Zf_Bilan: JSON.parse(sessionData.targetEnCours_Zf_Bilan),
        status: sessionData.status,
        resultsBilan: JSON.parse(
          sessionData.resultsBilan ? sessionData.resultsBilan : "[]"
        ),
        resultsZF: JSON.parse(
          sessionData.resultsZf ? sessionData.resultsZf : "[]"
        ),
        visualFieldSelectionId: sessionData.visualFieldSelectionId,
        visualFieldInput: JSON.parse(sessionData.visualFieldInput),
      };

      return sessionInfo;
    })
    .catch((error) => {
      console.error(
        "Erreur lors de la récupération des données de la séance:",
        error
      );
      throw error;
    });
};

export const realizeSessionEvolveSelection = async (
  sessionId: number,
  patientId: string,
  sessionType: "BILAN" | "REEDUCATION"
): Promise<void> => {
  try {
    const sessionInfo: SessionInfoItem = await getSessionInfo(sessionId);

    const selectionId = sessionInfo.visualFieldSelectionId;
    const inputCaseSession = sessionInfo.visualFieldInput;
    const resultZF = sessionInfo.resultsZF;
    const resultsBilan = sessionInfo.resultsBilan;
    const ZfSelected = sessionInfo.ZfSelected;
    const Bilan_CvSelected = sessionInfo.Bilan_CvSelected;
    console.log(
      "realizeSession called with sessionType:",
      'sessionType', sessionType,
      'resultsBilan', resultsBilan,
      'Bilan_CvSelected', Bilan_CvSelected,
      'resultZF', resultZF,
      'ZfSelected', ZfSelected,
      'inputCaseSession', inputCaseSession, 
      'selectionId', selectionId,
      'patientId', patientId
    );

    if (sessionType === "BILAN" && resultsBilan !== null && Bilan_CvSelected) {
      await updateSelectionBilan("practitioner", resultsBilan, patientId);

    } else if (
      sessionType === "REEDUCATION" &&
      resultZF &&
      ZfSelected
    ) {
      const evolvedSelection = evolveState(resultZF, inputCaseSession);
      try {
        await updateSelection(
          "practitioner",
          selectionId,
          evolvedSelection,
          patientId
        );
      } catch (error: unknown) {
        if (error instanceof Error) {
          console.error("Error updating selection:", error.message);
        } else {
          console.error("Unexpected error", error);
        }
      }
    }
  } catch (error) {
    console.error("Error realizing session:", error);
    throw error;
  }
};
